import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { useUser } from '../../hooks/useUser';
import { User } from '@/types/user';
import { httpOnlySecurityService } from '../../application/iam';
import { isPublicRoute } from '../../common/utils/routeUtils';

type AppFooterProps = {
  year?: number;
  version?: string;
  username?: string;
};

const AppFooter: React.FC<AppFooterProps> = ({ 
  year = new Date().getFullYear(),
    version = '12.0.0'
}) => {
  const {  } = useTranslation();
  const location = useLocation();
  const isPublic = isPublicRoute(location.pathname);
  
  // Check token validity before enabling useUser query
  // Read user data from cache only - UserInformationProvider handles fetching
  // This prevents duplicate requests - we only read from React Query cache
  const { data: userInfo, isLoading: isLoadingUser } = useUser(false);
  const user = userInfo as unknown as User | undefined;
  const username = user?.email || '';

  return (
    <footer className="h-8 background-[#E7EFF5] flex flex-none items-center px-6 justify-between">
      <div className="text-left flex items-center gap-2">
        <span className="text-[#385b68] text-xs font-normal font-['Lato']">
          iPep Version {version}
        </span>
        {username && (
          <span className="text-[#385b68] text-xs font-normal font-['Lato']">
            Logged in as: {username}
          </span>
        )}
      </div>
      <div className="text-right flex items-center gap-2">
        <a 
          href="https://www.ipc.be/about-ipc/privacystatement" 
          target="_blank" 
          rel="noopener noreferrer"
          className="text-[#385b68] text-xs font-normal font-['Lato'] underline cursor-pointer hover:text-[#2a4450]"
        >
          Privacy Policy
        </a>
        <span className="text-[#385b68] text-xs font-normal font-['Lato']">
          | © {year} IPC All rights reserved.
        </span>
      </div>
    </footer>
  );
};

export default AppFooter;
